import React from 'react';

import Button from '../Button/Button';

import styles from './ThanksModal.module.scss';

interface ThanksModalProps {
  onClose: () => void;
}

const ThanksModal: React.FC<ThanksModalProps> = ({ onClose }) => {
  const handleExploreNow = () => {
    onClose(); // Cierra el modal
    // Redirige al contenido freemium
    //window.location.href = 'https://play.umbra.stream/p/IICl5KrA/free-horror';
  };

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modalContent}>
        <div className={styles.imageContainer}>
          <img src="/images/thanks.jpg" alt="Gracias" className={styles.thanksImage} />
        </div>

        <h2 className={styles.title}>¡Gracias por registrarte!</h2>

        <p className={styles.message}>
          Ahora eres parte de la lista de invitados... de los condenados. Disfruta de tu contenido de inicio. Cuando el miedo gratis ya no sea suficiente,
          actualiza para la función principal y conoce a los verdaderos monstruos en la sección de pagos.
        </p>

        <Button label="Explorar Freemium" onClick={handleExploreNow} variant="contained" color="primary" size="large" fullWidth />
      </div>
    </div>
  );
};

export default ThanksModal;
